"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.demoPageParamsFromDataModel = void 0;
var _formMetadataParams = require("../formMetadataParams");
var _demoPageParams = require("./demoPageParams.schema");
const demoPageParamsFromDataModel = exports.demoPageParamsFromDataModel = _formMetadataParams.formMetadataParamsPreprocessSchema.pipe(_demoPageParams.demoPageParamsSchema);